<template lang="pug" src="./custom-treatment-accelerated-treatments.pug"></template>

<script>
export default {
  props: ['props'],
  mounted () {
    if (this.$route.hash === '#accelerated') {
      setTimeout(() => {
        this.$scrollTo('#accelerated', {offset: -140})
      }, 500)
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-treatment-accelerated-treatments.vue?c62a1bec